export const environment = {
    production: false,
    keycloakBaseUrl: 'https://sso.dev.services.utimaco.com',
    keycloakRealm: 'Utimaco-Portal-DEV',
    keycloakClientId: 'TaasTsFrontend',
    userManagementRestApiBasePath: 'https://sm-api.dev.services.utimaco.com/taas/sm/api/',
    taasPortalFrontendUrl: 'https://portal.dev.services.utimaco.com',
    timestampBackendRestApiUrl: 'https://tsaas-api.dev.services.utimaco.com/api/v1/',
};